import PlusIcon from "assets/icon/PlusIcon"

export default function AddButton({onClick, text}){
    return(
        <button className="flex justify-center items-center bg-black px-3 py-1 rounded-lg gap-2" onClick={ onClick }>
            <PlusIcon className="w-4 fill-white" />
            <span className="text-white text-sm">{text}</span>
        </button>
    )
}